import { scheduleIsCurrent } from 'lib/offer/scheduleStatusUtils'

/**
 * Checks if self-service rebook/upgrade is allowed for an offer.
 * Uses canUpgradePackage flag which has relaxed criteria for flash hotels
 * (allows upgrades outside policy deadline as long as within book-by date and 48h before check-in).
 */
export function isSelfServiceRebookAllowed(offer?: App.Offer, order?: App.Order, cancellationConfig?: App.OrderItemHotelCancellationConfig): boolean {
  if (!offer) return false
  if (order?.orderGift) return false
  // Use canUpgradePackage for upgrade eligibility check
  // This flag uses relaxed criteria for flash hotels (doesn't require being within policy deadline)
  if (!cancellationConfig?.canUpgradePackage) return false
  return !!offer.packageUpgradesAllowed && scheduleIsCurrent(offer.onlinePurchaseSchedule)
}
